import React, {
	useCallback,
	useContext,
	useEffect,
	useRef,
	useState,
} from 'react';
import { RiCloseFill } from 'react-icons/ri';
import { TbGhostFilled } from 'react-icons/tb';
import { RxCopy } from 'react-icons/rx';
import {
	BsDisplayFill,
	BsCameraVideo,
	BsCameraVideoOff,
	BsChat,
	BsFillMicFill,
	BsFillMicMuteFill,
	BsCameraVideoFill,
	BsCameraVideoOffFill,
} from 'react-icons/bs';
import MessageList from './MessageList';
import Textarea from './Textarea';
import { SdkContext } from '../context/SdkContext';
import CopyToClipboard from 'react-copy-to-clipboard';
import { RiFileCopyFill } from 'react-icons/ri';
import { Tooltip } from 'react-tooltip';
export default function Tab({
	participants,
	screenShare,
	showSidebar,
	updateScreenShareInfo,
	onOffSidebar,
	handleLocalAudioMuteState,
	handleLocalVideoMuteState,
}) {
	const omnitalk = useContext(SdkContext);
	const [typingMessage, setTypingMessage] = useState(''); // 사용자 입력 메시지
	const [debouncedTypingMessage, setDebouncedTypingMessage] = useState('');
	const [msg, setMsg] = useState([]);
	const msgRef = useRef(null);
	const [isWhisper, setIsWhisper] = useState(false);
	const [whisperUserSession, setWhistperUserSession] = useState('');
	const [videoMuteToggle, setVideoMuteToggle] = useState('off');
	const [audioMuteToggle, setAudioMuteToggle] = useState('off');

	useEffect(() => {
		const delayInputTimeoutId = setTimeout(() => {
			setDebouncedTypingMessage(typingMessage);
		}, 500);
		return () => clearTimeout(delayInputTimeoutId);
	}, [typingMessage, 500]); //debounce typingMessage

	const makeMyMessage = data => {
		return {
			content: data,
			from: '나',
		};
	};
	const handleChangeTypingMessage = useCallback(event => {
		setTypingMessage(event.target.value);
	}, []);
	const handleWhisperSession = useCallback(event => {
		setWhistperUserSession(event.target.value);
	});
	const handleIsWhisper = useCallback(event => {
		setIsWhisper(prev => !prev);
	});
	const moveScrollToReceiveMessage = useCallback(() => {
		if (msgRef.current) {
			msgRef.current.scrollTo({
				top: msgRef.current.scrollHeight,
				behavior: 'smooth',
			});
		}
	}, []);
	useEffect(() => {
		omnitalk.on('event', async msg => {
			switch (msg.cmd) {
				case 'MESSAGE_EVENT':
					console.log(`😶💌💌 Message: ${JSON.stringify(msg)}`);
					if (msg.action === 'send') {
						const data = { content: msg.message, from: msg.user_id };
						makeRemoteMessage(data);
					} else {
						const data = {
							content: msg.message,
							from: msg.user_id,
							whisper: true,
						};
						makeRemoteMessage(data);
					}
					break;
				default:
					break;
			}
		});
	}, []);
	useEffect(() => {
		moveScrollToReceiveMessage();
	}, [msg]);

	function makeRemoteMessage(data) {
		setMsg(prevMsg => [...prevMsg, data]);
	}
	const handleSendMesssage = useCallback(async () => {
		const noContent = typingMessage.trim() === '';
		if (noContent) {
			return;
		}
		const resultMsg = makeMyMessage(typingMessage);
		setMsg(prevMsg => [...prevMsg, resultMsg]);

		try {
			if (isWhisper) {
				await omnitalk.sendWhisper(typingMessage, whisperUserSession);
			} else {
				await omnitalk.sendMessage(typingMessage);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setTypingMessage('');
			setIsWhisper(false);
			setWhistperUserSession('');
		}
	}, [typingMessage]);

	return (
		<div className={` w-[35%]  ${showSidebar ? '' : 'hidden'}`}>
			<div className="flex container justify-end p-4  bg-charcoal-200  ">
				<button type="button">
					<RiCloseFill
						onClick={() => onOffSidebar()}
						className="text-white mr-3 w-6 h-6"
					></RiCloseFill>
				</button>
			</div>
			<div className="content  bg-charcoal-200 ">
				<>
					<div className="container p-5  w-full h-screen ">
						<div className="h-[30vh]">
							<div className="flex items-center">
								<div className="w-10 h-10 bg-charcoal-50 rounded-sm mr-3"></div>
								<span className="mr-3 text-white">나 (me)</span>

								<div className="ml-auto flex gap-1 ">
									{/* video control */}
									{videoMuteToggle === 'off' ? (
										<>
											<button
												className="bg-orange-500 px-3 py-2 rounded-sm text-white "
												onClick={async () => {
													try {
														await omnitalk.setMute('video');
													} catch (error) {
														console.log(error);
													}
													setVideoMuteToggle('on');
													handleLocalVideoMuteState();
												}}
											>
												<BsCameraVideoOffFill className="w-5 h-5"></BsCameraVideoOffFill>
											</button>
										</>
									) : (
										<>
											<button
												className="bg-orange-500 px-3 py-2 rounded-sm text-white  "
												onClick={async () => {
													try {
														await omnitalk.setUnmute('video');
													} catch (error) {
														console.log(error);
													}
													setVideoMuteToggle('off');
													handleLocalVideoMuteState();
												}}
											>
												<BsCameraVideoFill className="w-5 h-5"></BsCameraVideoFill>
											</button>
										</>
									)}
									{/* audio control */}
									{audioMuteToggle === 'off' ? (
										<>
											<button
												className="bg-orange-500 px-3 py-2 rounded-sm text-white  "
												onClick={async () => {
													try {
														await omnitalk.setMute('audio');
													} catch (error) {
														console.log(error);
													}
													setAudioMuteToggle('on');
													handleLocalAudioMuteState();
												}}
											>
												<BsFillMicMuteFill className="w-5 h-5"></BsFillMicMuteFill>
											</button>
										</>
									) : (
										<>
											<button
												className="bg-orange-500 px-3 py-2 rounded-sm text-white  "
												onClick={async () => {
													try {
														await omnitalk.setUnmute('audio');
													} catch (error) {
														console.log(error);
													}
													setAudioMuteToggle('off');
													handleLocalAudioMuteState();
												}}
											>
												<BsFillMicFill className="w-5 h-5"></BsFillMicFill>
											</button>
										</>
									)}
								</div>
							</div>

							{participants.map((participant, i) => {
								return (
									<div className="flex items-center mt-4" key={i}>
										<div className="w-10 h-10 bg-charcoal-50 rounded-sm mr-3"></div>
										<span className="mr-3 text-white">
											{participant.userId}
										</span>

										<div className="flex ml-auto items-center">
											{participant.userId === screenShare.userId && (
												<>
													{' '}
													<a
														data-tooltip-id={participant.userId}
														data-tooltip-content="화면공유 구독"
														className="flex"
													>
														<button
															className="text-sm"
															onClick={async () => {
																const data = { show: true };
																updateScreenShareInfo(data);
																try {
																	await omnitalk.subscribe(
																		screenShare.session,
																		'sharing',
																	);
																} catch (error) {
																	console.log(error);
																}
															}}
														>
															<BsDisplayFill className="w-6 h-6 mr-3 text-gray-200"></BsDisplayFill>
														</button>
													</a>
													<Tooltip id={participant.userId} />
												</>
											)}

											<a
												data-tooltip-id={participant.session}
												data-tooltip-content="세션 복사"
												className="flex"
											>
												<CopyToClipboard text={participant.session}>
													<button className="text-sm">
														<RiFileCopyFill className="w-6 h-6 mr-3 text-gray-200"></RiFileCopyFill>
													</button>
												</CopyToClipboard>
											</a>
											<Tooltip id={participant.session} />

											{/* <CopyToClipboard text={participant.session}>
                      <button className="text-sm">
                        <RiFileCopyFill className="w-6 h-6 mr-3 text-gray-200"></RiFileCopyFill>
                      </button>
                    </CopyToClipboard> */}
											<button
												onClick={async () => {
													try {
														await omnitalk.subscribe(
															participant.session,
															participant.userId,
														);
													} catch (error) {}
												}}
												className="bg-teal-500 px-4 py-2 rounded-sm text-white font-medium mr-2"
											>
												구독
											</button>
											<button
												className="bg-rose-500 px-4 py-2 rounded-sm text-white font-medium"
												onClick={async () => {
													try {
														await omnitalk.unsubscribe(
															participant.session,
															participant.userId,
														);
													} catch (error) {
														console.log(error);
													}
												}}
											>
												구독 취소
											</button>
										</div>
									</div>
								);
							})}
						</div>
						<div className="h-[50vh] ">
							<div
								className="h-[100%] overflow-y-auto text-white "
								ref={msgRef}
							>
								<MessageList msg={msg}></MessageList>
							</div>
						</div>
						<div className="flex items-center text-white mt-5">
							<input
								type="text"
								className="w-[75%] text-black placeholder-gray-400 mr-4"
								placeholder="  귓속말을 보낼 상대의 세션"
								onChange={handleWhisperSession}
							></input>
							<input
								type="checkbox"
								checked={isWhisper}
								onChange={handleIsWhisper}
								className="w-4 h-4 mr-3"
							></input>
							귓속말
							{/* <TbGhostFilled className="text-gray-200 w-8 h-8"></TbGhostFilled> */}
						</div>
						<div className="flex mt-4">
							<Textarea
								className="flex  mr-4 w-full text-black"
								placeholder="메시지를 입력하세요"
								value={typingMessage}
								onChange={handleChangeTypingMessage}
								onPressEnter={handleSendMesssage}
							></Textarea>
							<button
								value="send"
								onClick={handleSendMesssage}
								type="button"
								className="bg-main text-white p-4 rounded-md"
							>
								send
							</button>
						</div>
					</div>
				</>
			</div>
		</div>
	);
}
